import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { KitchenEditView } from 'src/sections/kitchen/view';

export default function KitchenEditPage() {
  const params = useParams();

  const { user: authUser } = useAuthContext();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title>Inventory Item Edit</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.UPDATE_KITCHEN_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <KitchenEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
